var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupPerIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05554 8.1105C7.05554 8.93562 7.38332 9.72694 7.96676 10.3104C8.55021 10.8938 9.34153 11.2216 10.1667 11.2216C10.9918 11.2216 11.7831 10.8938 12.3665 10.3104C12.95 9.72694 13.2778 8.93562 13.2778 8.1105C13.2778 7.28538 12.95 6.49406 12.3665 5.91061C11.7831 5.32717 10.9918 4.99939 10.1667 4.99939C9.34153 4.99939 8.55021 5.32717 7.96676 5.91061C7.38332 6.49406 7.05554 7.28538 7.05554 8.1105Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49994 18.9991V17.4435C5.49994 16.6184 5.82772 15.8271 6.41116 15.2436C6.99461 14.6602 7.78593 14.3324 8.61105 14.3324H11.7222C12.5473 14.3324 13.3386 14.6602 13.922 15.2436C14.5055 15.8271 14.8333 16.6184 14.8333 17.4435V18.9991",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6113 5.10095C16.2805 5.2723 16.8736 5.6615 17.2972 6.20719C17.7208 6.75289 17.9507 7.42404 17.9507 8.11484C17.9507 8.80564 17.7208 9.47679 17.2972 10.0225C16.8736 10.5682 16.2805 10.9574 15.6113 11.1287",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.0006V17.445C19.4961 16.7584 19.2651 16.0923 18.843 15.5507C18.4209 15.009 17.8316 14.6222 17.1667 14.4506",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPerIc);
export default __webpack_public_path__ + "static/media/group_per_ic.36aeda9b04369c5ee167aca7da6610b6.svg";
export { ForwardRef as ReactComponent };